module.exports = __webpack_public_path__ + "static/img/why-6.887e6e19.jpg";